'use client';
import analytics from '@lisoft/analytics';

if (typeof window !== 'undefined') {
  analytics.init({
    debug: process.env['NODE_ENV'] === 'development',
    baseProps: {
      product: 'NestFlow',
      component: 'nestflow',
    },
  });
}

export default function Analytics() {
  return null;
}
